import { render, staticRenderFns } from "./SupplierEmail.vue?vue&type=template&id=5a99aae0"
import script from "./SupplierEmail.vue?vue&type=script&lang=js"
export * from "./SupplierEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports